import { useTranslations } from "next-intl";
import { IDCart } from "../_icons/idCard";

interface AgeRestrictedProps {
  textClassName?: string;
  text?: string;
  "data-testid"?: string;
}

export const AgeRestricted = ({
  textClassName,
  text,
  "data-testid": dataTestId,
}: AgeRestrictedProps) => {
  const t = useTranslations("AgeRestricted");
  return (
    <div className="flex gap-3 py-2" data-testid={dataTestId}>
      <div className="flex-shrink-0">
        <IDCart />
      </div>
      <p className={`font-weight-[400] text-[#000000] text-left ${textClassName}`}>
        {text || t("text")}
      </p>
    </div>
  );
};
